import { FC, ReactNode, CSSProperties } from "react";
import styles from "./Card.module.css";

interface CardProps {
  children: ReactNode;
  classes?: string;
  variant?: "v1" | "v2";
  style?: CSSProperties;
}

/**
 * Internal Card component for ContentQualityWidget
 */
const Card: FC<CardProps> = ({
  children,
  classes = "",
  variant = "v1",
  style,
  ...rest
}) => {
  const variantClass = variant === "v2" ? styles.cardV2 : styles.card;

  return (
    <div className={`${variantClass} ${classes}`} style={style} {...rest}>
      {children}
    </div>
  );
};

Card.displayName = "Card";
export default Card;
